
export const data = [
	{
		title: "Drive-01",
		description: "Example description of the content that could go inside.",
		ownerName: "Owner name",
		version: "1.3.2",
		lock: "89",
		documents: "10",
		list: [
			{
				title: "Customer Service Manual v2.1.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
			{
				title: "Product Guidelines Q4.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
			{
				title: "Training Materials 2024.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
			{
				title: "Sales Process Documentation.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
			{
				title: "Technical Specifications.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
		]
	},
	{
		title: "Drive-07",
		description: "Example description of the content that could go inside.",
		ownerName: "Owner name",
		version: "1.3.2",
		lock: "89",
		documents: "10",
		list: [
			{
				title: "Marketing Strategy 2024.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
			{
				title: "Financial Reports Q3.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
			{
				title: "HR Policies Updated.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
			{
				title: "Project Timeline Overview.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
			{
				title: "Client Onboarding Guide.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
		]
	},
	{
		title: "Drive-07",
		description: "Example description of the content that could go inside.",
		ownerName: "Owner name",
		version: "1.3.2",
		lock: "89",
		documents: "10",
		list: [
			{
				title: "API Documentation v3.0.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
			{
				title: "User Experience Guidelines.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
			{
				title: "Data Privacy Policy.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
			{
				title: "Quality Assurance Checklist.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
			{
				title: "Maintenance Schedule 2024.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
		]
	},
	{
		title: "Drive-07",
		description: "Example description of the content that could go inside.",
		ownerName: "Owner name",
		version: "1.3.2",
		lock: "89",
		documents: "10",
		list: [
			{
				title: "Security Protocols.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
			{
				title: "Performance Metrics Report.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
			{
				title: "Compliance Documentation.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
			{
				title: "Team Collaboration Guidelines.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
			{
				title: "Innovation Roadmap 2025.pdf",
				description: "A concise manual for customer service detailing escalation steps, response templates, and quality benchmarks for support teams.",
				ownerName: "Owner name",
				version: "1.3.2",
				lock: "100",
			},
		]
	}
];
